export default __webpack_public_path__ + "static/media/back-arrow.102f61ad.svg";